import React, { useState } from "react";
import PropTypes from "prop-types";
import { addToFavoritePanels, getFavoritePanels, removeFromFavoritePanel } from "./favorite.service";

const defaultState = {
    favoritePanels: null
};

const defaultActions = {
    addToFavorites: _id => {},
    removeFromFavorites: _id => {}
};

export const FavoriteContext = React.createContext({
    ...defaultState,
    ...defaultActions
});
export const FavoriteConsumer = FavoriteContext.Consumer;

const FavoriteProvider = props => {
    const [favoritePanels, setFavoritePanels] = useState([]);

    const addToFavorites = id => {
        const favPanels = addToFavoritePanels(id);
        setFavoritePanels([...favPanels]);
    };

    const removeFromFavorites = id => {
        const favPanels = removeFromFavoritePanel(id);
        setFavoritePanels([...favPanels]);
    };

    const fetchFavorites = () => {
        const favPanels = getFavoritePanels();
        setFavoritePanels([...favPanels]);
    };
    React.useEffect(() => {
        fetchFavorites();
    }, []);

    const state = {
        favoritePanels,
        addToFavorites,
        removeFromFavorites
    };

    return <FavoriteContext.Provider value={state}>{props.children}</FavoriteContext.Provider>;
};

FavoriteProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export const useFavoriteStateValue = () => React.useContext(FavoriteContext);

export default FavoriteProvider;
